import { FormBase } from 'core/components';

export default class OnHoldForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'sellerId',
					label: 'Seller',
				},
			],
		};
	}
}
